<template lang="pug">
#safety-confirm-register-complete
  // title
  .d-flex.flex-row.justify-content-center.mb-2
    .page-title 安否確認の新規作成

  // progress
  ProcessIndicator(v-model="indicator")
  .mb-3.separator

  // message
  .mb-3 安否確認の登録が完了しました。

  // buttons
  .d-flex.flex-row.justify-content-center
    b-button.btn.back-btn(@click="onGotoList") 安否確認一覧へ

</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import ProcessIndicator, { ProcessIndicatorModel } from "@/mobile/basics/ProcessIndicator.vue";
import { MobileUrl } from "@/commons/constants/MobileUrl";

/**
 * ### 安否確認 登録情報 完了コンポーネント
 */
@Component({
  components: {
    ProcessIndicator
  }
})
export default class SafetyConfirmRegisterComplete extends Vue {
  /** インジケータ */
  indicator: Array<ProcessIndicatorModel> = [
    { text: "入力", current: false },
    { text: "確認", current: false },
    { text: "完了", current: true }
  ];

  /**
   * ### 安否確認一覧へボタン押下イベント
   *
   * - 安否確認一覧画面へ遷移する
   */
  public onGotoList(): void {
    this.$router.push(MobileUrl.SafetyConfirmList);
    return;
  }
}
</script>
